/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type RbacConfigInitializedEvent = {
  rbacConfig: Address;
  authority: Address;
  rolesCount: number;
};

export type RbacConfigInitializedEventArgs = RbacConfigInitializedEvent;

export function getRbacConfigInitializedEventEncoder(): FixedSizeEncoder<RbacConfigInitializedEventArgs> {
  return getStructEncoder([
    ["rbacConfig", getAddressEncoder()],
    ["authority", getAddressEncoder()],
    ["rolesCount", getU32Encoder()],
  ]);
}

export function getRbacConfigInitializedEventDecoder(): FixedSizeDecoder<RbacConfigInitializedEvent> {
  return getStructDecoder([
    ["rbacConfig", getAddressDecoder()],
    ["authority", getAddressDecoder()],
    ["rolesCount", getU32Decoder()],
  ]);
}

export function getRbacConfigInitializedEventCodec(): FixedSizeCodec<
  RbacConfigInitializedEventArgs,
  RbacConfigInitializedEvent
> {
  return combineCodec(
    getRbacConfigInitializedEventEncoder(),
    getRbacConfigInitializedEventDecoder(),
  );
}
